import styles from './styles.module.css';

type WorkingHour = {
  day: string;
  hours: string;
  closed?: boolean;
};

const workingHours: WorkingHour[] = [
  { day: 'شنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'یک‌شنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'دوشنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'سه‌شنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'چهارشنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'پنج‌شنبه', hours: '۹:۰۰ تا ۱۹:۰۰' },
  { day: 'جمعه', hours: 'تعطیل', closed: true },
];

export default function ShopWorkingHours() {
  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>ساعت کاری هفته</h2>

      <div className={styles.list}>
        {workingHours.map((item, index) => (
          <div
            key={item.day}
            className={`${styles.row} ${
              item.closed ? styles.closedRow : index % 2 === 1 ? styles.altRow : ''
            }`}
          >
            <span className={`${styles.day} ${item.closed ? styles.closedDay : ''}`}>
              {item.day}
            </span>

            <span className={`${styles.hours} ${item.closed ? styles.closedHours : ''}`}>
              {item.hours}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
